"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class EvErrorCode {
    static EventRequired = 0;
    static ClaimsRequired = 1;
    static MissingClaim = 2;
    static QueryStringParametersRequired = 3;
    static MissingQueryStringParameter = 4;
    static InvalidParameterType = 5;
    static BodyRequired = 6;
    static InvalidBody = 7;
    static PathParametersRequired = 8;
    static MissingPathParameter = 9;
    static HeadersRequired = 10;
    static HeaderRequired = 11;
    static MissingJwt = 12;
}
exports.default = EvErrorCode;
